import { render, staticRenderFns } from "./Xgmm.vue?vue&type=template&id=217ce231&scoped=true"
import script from "./Xgmm.vue?vue&type=script&lang=js"
export * from "./Xgmm.vue?vue&type=script&lang=js"
import style0 from "./Xgmm.vue?vue&type=style&index=0&id=217ce231&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217ce231",
  null
  
)

export default component.exports